// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dispatch-wizard {
  width: 100%;
}

.dispatch-wizard__intro h2 {
  margin: 0 0 0.35rem;
  font-size: clamp(1.6rem, 4vw, 2.2rem);
  font-weight: 700;
}

.dispatch-wizard__intro p {
  margin: 0 0 1.5rem;
  color: var(--color-text-muted);
  font-size: 0.95rem;
}

.wizard-step {
  padding: 1.25rem;
  margin-bottom: 1rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
  background: var(--color-surface-raised);
  box-shadow: var(--shadow);
}

.wizard-step__header {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  margin-bottom: 1.25rem;
}

.wizard-step__header h3 {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 700;
}

.wizard-step__badge {
  display: grid;
  place-items: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: var(--color-tertiary);
  color: var(--color-text-muted);
  font-size: 0.9rem;
  font-weight: 700;
  flex-shrink: 0;
}

.wizard-step__badge--active {
  background: var(--color-accent);
  color: var(--color-on-accent);
}

.wizard-field__label {
  display: block;
  margin-bottom: 0.65rem;
  color: var(--color-text-muted);
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.wizard-field__hint {
  margin: -0.35rem 0 1rem;
  color: var(--color-text-muted);
  font-size: 0.82rem;
}

.wizard-field__hint--spaced {
  margin: 0 0 1rem;
}

.wizard-quota-summary {
  margin: 0 0 1rem;
  color: var(--color-text);
  font-size: 0.92rem;
}

.wizard-quota-summary__meta {
  color: var(--color-text-muted);
  font-size: 0.84rem;
}

.wizard-sender-mode {
  display: grid;
  gap: 0.75rem;
  margin-bottom: 1rem;
}

.wizard-sender-mode__option {
  display: flex;
  gap: 0.85rem;
  align-items: flex-start;
  padding: 1rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
  background: var(--color-surface);
  cursor: pointer;
  transition: border-color 0.2s ease, background 0.2s ease;
}

.wizard-sender-mode__option:hover {
  border-color: var(--color-accent);
}

.wizard-sender-mode__option--selected {
  border-color: var(--color-accent);
  background: var(--color-accent-soft);
}

.wizard-sender-mode__option input {
  margin-top: 0.2rem;
  accent-color: var(--color-accent);
  flex-shrink: 0;
}

.wizard-sender-mode__content {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.wizard-sender-mode__title {
  font-size: 0.95rem;
  font-weight: 700;
}

.wizard-sender-mode__description {
  color: var(--color-text-muted);
  font-size: 0.85rem;
  line-height: 1.45;
}

.wizard-sender-mode__preview {
  color: var(--color-accent);
  font-size: 0.82rem;
  font-weight: 600;
}

.wizard-sender-mode__preview--warning {
  color: var(--color-secondary);
}

.wizard-sender-table {
  --wizard-sender-row-height: 48px;
  margin-bottom: 1rem;
}

.wizard-sender-table--scrollable .rdt_TableHead {
  position: sticky;
  top: 0;
  z-index: 1;
}

.wizard-sender-table--scrollable .rdt_TableBody {
  max-height: calc(var(--wizard-sender-row-height) * 10);
  overflow-y: auto;
}

.wizard-sender-table.data-page__rdt input[type='checkbox'] {
  accent-color: var(--color-accent);
  cursor: pointer;
}

.wizard-input--datetime {
  max-width: 320px;
  margin-bottom: 0;
}

.wizard-summary {
  display: flex;
  flex-direction: column;
  gap: 0;
  margin: 0 0 1.25rem;
  padding: 0;
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
  background: var(--color-surface);
  overflow: hidden;
}

.wizard-summary__row {
  display: grid;
  grid-template-columns: 8.5rem minmax(0, 1fr);
  gap: 1rem;
  align-items: start;
  margin: 0;
  padding: 0.9rem 1rem;
  border-bottom: 1px solid var(--color-border);
}

.wizard-summary__row:last-child {
  border-bottom: none;
}

.wizard-summary__row dt {
  margin: 0;
  color: var(--color-text-muted);
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  line-height: 1.4;
}

.wizard-summary__row dd {
  margin: 0;
  color: var(--color-text);
  font-size: 0.92rem;
  line-height: 1.45;
  word-break: break-word;
}

.wizard-summary__line {
  display: block;
}

.wizard-summary__line + .wizard-summary__line {
  margin-top: 0.35rem;
}

.wizard-summary__line--accent {
  color: var(--color-accent);
  font-size: 0.86rem;
  font-weight: 600;
}

.wizard-summary__body {
  margin: 0;
  max-height: 12rem;
  overflow: auto;
  padding: 0.75rem 0.85rem;
  border: 1px solid var(--color-border);
  border-radius: calc(var(--radius) - 2px);
  background: var(--color-bg, transparent);
  color: var(--color-text);
  font: inherit;
  font-size: 0.88rem;
  line-height: 1.5;
  white-space: pre-wrap;
  word-break: break-word;
}

.wizard-dispatch-actions {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  gap: 0.75rem;
}

@media (max-width: 640px) {
  .wizard-summary__row {
    grid-template-columns: 1fr;
    gap: 0.35rem;
  }
}

.wizard-schedule-field {
  width: 100%;
}

.wizard-dispatch-actions .wizard-upload__error {
  margin: 0;
}

.wizard-btn--dispatch {
  display: inline-flex;
  align-self: flex-start;
  margin-top: 0.25rem;
  /* Match Add Files (wizard-btn--secondary) */
  background: var(--color-btn);
  color: var(--color-btn-text);
}

.wizard-btn--dispatch:hover:not(:disabled) {
  filter: brightness(1.08);
  background: var(--color-btn-hover);
}

.wizard-btn--dispatch svg {
  color: var(--color-icon);
}

.wizard-upload {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 180px;
  margin-bottom: 0.75rem;
  padding: 1.5rem;
  border: 1px dashed var(--color-border);
  border-radius: var(--radius);
  background: var(--color-surface);
  cursor: pointer;
  transition: border-color 0.2s ease, background 0.2s ease;
}

.wizard-upload--disabled {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
}

.wizard-upload:hover,
.wizard-upload:focus-visible {
  border-color: var(--color-accent);
  background: var(--color-accent-soft);
  outline: none;
}

.wizard-upload__input {
  display: none;
}

.wizard-upload__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  margin-bottom: 0.75rem;
  border-radius: 12px;
  background: var(--color-btn);
  color: var(--color-icon);
}

.wizard-upload__icon svg {
  width: 28px;
  height: 28px;
}

.wizard-upload__title {
  margin: 0 0 0.35rem;
  font-size: 0.95rem;
  font-weight: 600;
}

.wizard-upload__hint {
  margin: 0;
  color: var(--color-text-muted);
  font-size: 0.68rem;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.wizard-upload__error {
  margin: 0 0 1rem;
  color: var(--color-secondary);
  font-size: 0.88rem;
}

.dispatch-toast {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.dispatch-toast strong {
  font-size: 0.95rem;
}

.dispatch-toast span {
  font-size: 0.85rem;
  line-height: 1.45;
  opacity: 0.92;
}

.dispatch-toast code {
  font-family: 'Courier New', Courier, monospace;
  font-size: 0.72rem;
  opacity: 0.85;
  word-break: break-all;
}

.wizard-validation {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 0.75rem;
  margin-top: 1.25rem;
}

.wizard-validation__card {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding: 1rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
  background: var(--color-surface);
}

.wizard-validation__card--success {
  border-color: var(--color-accent);
}

.wizard-validation__card--success .wizard-validation__count {
  color: var(--color-accent);
}

.wizard-validation__card--warning .wizard-validation__count {
  color: var(--color-secondary);
}

.wizard-validation__count {
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.2;
}

.wizard-validation__label {
  color: var(--color-text-muted);
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
}

.wizard-step--disabled {
  opacity: 0.6;
  pointer-events: none;
}

.wizard-input,
.wizard-textarea {
  width: 100%;
  margin-bottom: 1.25rem;
  padding: 0.85rem 1rem;
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
  background: var(--color-surface);
  color: var(--color-text);
  font: inherit;
}

.wizard-input::placeholder,
.wizard-textarea::placeholder {
  color: var(--color-text-muted);
}

.wizard-input:focus,
.wizard-textarea:focus {
  outline: none;
  border-color: var(--color-accent);
  box-shadow: 0 0 0 3px var(--color-accent-soft);
}

.wizard-textarea {
  min-height: 180px;
  resize: vertical;
  font-family: 'Courier New', Courier, monospace;
  line-height: 1.5;
}

.wizard-attachments {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}

.wizard-attachments__list {
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
  border: 1px solid var(--color-border);
  border-radius: var(--radius);
  background: var(--color-surface);
  overflow: hidden;
}

.wizard-attachments__list li {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto auto;
  gap: 0.75rem;
  align-items: center;
  padding: 0.7rem 0.85rem;
  border-bottom: 1px solid var(--color-border);
}

.wizard-attachments__list li:last-child {
  border-bottom: 0;
}

.wizard-attachments__name {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.9rem;
  font-weight: 600;
}

.wizard-attachments__meta {
  color: var(--color-text-muted);
  font-size: 0.78rem;
  white-space: nowrap;
}

.wizard-attachments__remove {
  border: 0;
  background: transparent;
  color: var(--color-secondary);
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  cursor: pointer;
  padding: 0;
}

.wizard-attachments__remove:hover:not(:disabled) {
  text-decoration: underline;
}

.wizard-attachments__remove:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.wizard-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.55rem;
  padding: 0.75rem 1.1rem;
  border: none;
  border-radius: var(--radius);
  background: var(--color-btn);
  color: var(--color-btn-text);
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  cursor: pointer;
  transition: filter 0.2s ease, background 0.2s ease;
}

.wizard-btn svg {
  width: 16px;
  height: 16px;
  color: var(--color-icon);
}

.wizard-btn--secondary:hover:not(:disabled),
.wizard-btn--primary:hover:not(:disabled) {
  filter: brightness(1.08);
  background: var(--color-btn-hover);
}

.wizard-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.wizard-btn__spinner {
  width: 16px;
  height: 16px;
  border: 2px solid currentColor;
  border-top-color: transparent;
  border-radius: 50%;
  animation: wizard-spin 0.7s linear infinite;
}

@keyframes wizard-spin {
  to {
    transform: rotate(360deg);
  }
}

.wizard-btn--primary {
  width: 100%;
  justify-content: center;
  margin-top: 0.25rem;
}

.wizard-footnote {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  margin: 0.85rem 0 0;
  color: var(--color-text-muted);
  font-size: 0.72rem;
}

.wizard-footnote svg {
  width: 14px;
  height: 14px;
  color: var(--color-icon);
  padding: 3px;
  border-radius: 4px;
  background: var(--color-btn);
  box-sizing: content-box;
}

@media (max-width: 768px) {
  .wizard-step {
    padding: 1rem;
  }

  .wizard-upload {
    min-height: 150px;
    padding: 1.25rem 1rem;
  }

  .wizard-validation {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 480px) {
  .dispatch-wizard__intro p {
    margin-bottom: 1.25rem;
  }

  .wizard-step__header h3 {
    font-size: 0.95rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/SendEmail.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;EACrC,4BAA4B;EAC5B,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,aAAa;EACb,qCAAqC;EACrC,4BAA4B;EAC5B,gCAAgC;EAChC,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,sDAAsD;EACtD,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;EACN,mBAAmB;EACnB,UAAU;EACV,qCAAqC;EACrC,4BAA4B;EAC5B,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,SAAS;EACT,kBAAkB;EAClB,SAAS;EACT,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,wBAAwB;EACxB,qCAAqC;EACrC,wCAAwC;EACxC,wCAAwC;EACxC,wBAAwB;EACxB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,WAAW;EACX,YAAY;AACd;;AAEA;EACE;IACE,0BAA0B;IAC1B,YAAY;EACd;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,mBAAmB;EACnB,4CAA4C;EAC5C,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,sCAAsC;EACtC,4BAA4B;EAC5B,gCAAgC;EAChC,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;EAEE,iCAAiC;EACjC,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,4BAA4B;EAC5B,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,8CAA8C;EAC9C,kBAAkB;EAClB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,4BAA4B;EAC5B,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;;EAEE,WAAW;EACX,sBAAsB;EACtB,qBAAqB;EACrB,qCAAqC;EACrC,4BAA4B;EAC5B,gCAAgC;EAChC,wBAAwB;EACxB,aAAa;AACf;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,aAAa;EACb,iCAAiC;EACjC,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,qCAAqC;EACrC,4BAA4B;EAC5B,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,+CAA+C;EAC/C,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,4BAA4B;EAC5B,4BAA4B;EAC5B,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;;EAEE,wBAAwB;EACxB,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,6BAA6B;EAC7B,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".dispatch-wizard {\n  width: 100%;\n}\n\n.dispatch-wizard__intro h2 {\n  margin: 0 0 0.35rem;\n  font-size: clamp(1.6rem, 4vw, 2.2rem);\n  font-weight: 700;\n}\n\n.dispatch-wizard__intro p {\n  margin: 0 0 1.5rem;\n  color: var(--color-text-muted);\n  font-size: 0.95rem;\n}\n\n.wizard-step {\n  padding: 1.25rem;\n  margin-bottom: 1rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius);\n  background: var(--color-surface-raised);\n  box-shadow: var(--shadow);\n}\n\n.wizard-step__header {\n  display: flex;\n  align-items: center;\n  gap: 0.85rem;\n  margin-bottom: 1.25rem;\n}\n\n.wizard-step__header h3 {\n  margin: 0;\n  font-size: 1.05rem;\n  font-weight: 700;\n}\n\n.wizard-step__badge {\n  display: grid;\n  place-items: center;\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  background: var(--color-tertiary);\n  color: var(--color-text-muted);\n  font-size: 0.9rem;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.wizard-step__badge--active {\n  background: var(--color-accent);\n  color: var(--color-on-accent);\n}\n\n.wizard-field__label {\n  display: block;\n  margin-bottom: 0.65rem;\n  color: var(--color-text-muted);\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.wizard-field__hint {\n  margin: -0.35rem 0 1rem;\n  color: var(--color-text-muted);\n  font-size: 0.82rem;\n}\n\n.wizard-field__hint--spaced {\n  margin: 0 0 1rem;\n}\n\n.wizard-quota-summary {\n  margin: 0 0 1rem;\n  color: var(--color-text);\n  font-size: 0.92rem;\n}\n\n.wizard-quota-summary__meta {\n  color: var(--color-text-muted);\n  font-size: 0.84rem;\n}\n\n.wizard-sender-mode {\n  display: grid;\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n}\n\n.wizard-sender-mode__option {\n  display: flex;\n  gap: 0.85rem;\n  align-items: flex-start;\n  padding: 1rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius);\n  background: var(--color-surface);\n  cursor: pointer;\n  transition: border-color 0.2s ease, background 0.2s ease;\n}\n\n.wizard-sender-mode__option:hover {\n  border-color: var(--color-accent);\n}\n\n.wizard-sender-mode__option--selected {\n  border-color: var(--color-accent);\n  background: var(--color-accent-soft);\n}\n\n.wizard-sender-mode__option input {\n  margin-top: 0.2rem;\n  accent-color: var(--color-accent);\n  flex-shrink: 0;\n}\n\n.wizard-sender-mode__content {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.wizard-sender-mode__title {\n  font-size: 0.95rem;\n  font-weight: 700;\n}\n\n.wizard-sender-mode__description {\n  color: var(--color-text-muted);\n  font-size: 0.85rem;\n  line-height: 1.45;\n}\n\n.wizard-sender-mode__preview {\n  color: var(--color-accent);\n  font-size: 0.82rem;\n  font-weight: 600;\n}\n\n.wizard-sender-mode__preview--warning {\n  color: var(--color-secondary);\n}\n\n.wizard-sender-table {\n  --wizard-sender-row-height: 48px;\n  margin-bottom: 1rem;\n}\n\n.wizard-sender-table--scrollable .rdt_TableHead {\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\n.wizard-sender-table--scrollable .rdt_TableBody {\n  max-height: calc(var(--wizard-sender-row-height) * 10);\n  overflow-y: auto;\n}\n\n.wizard-sender-table.data-page__rdt input[type='checkbox'] {\n  accent-color: var(--color-accent);\n  cursor: pointer;\n}\n\n.wizard-input--datetime {\n  max-width: 320px;\n  margin-bottom: 0;\n}\n\n.wizard-summary {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n  margin: 0 0 1.25rem;\n  padding: 0;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius);\n  background: var(--color-surface);\n  overflow: hidden;\n}\n\n.wizard-summary__row {\n  display: grid;\n  grid-template-columns: 8.5rem minmax(0, 1fr);\n  gap: 1rem;\n  align-items: start;\n  margin: 0;\n  padding: 0.9rem 1rem;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.wizard-summary__row:last-child {\n  border-bottom: none;\n}\n\n.wizard-summary__row dt {\n  margin: 0;\n  color: var(--color-text-muted);\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  line-height: 1.4;\n}\n\n.wizard-summary__row dd {\n  margin: 0;\n  color: var(--color-text);\n  font-size: 0.92rem;\n  line-height: 1.45;\n  word-break: break-word;\n}\n\n.wizard-summary__line {\n  display: block;\n}\n\n.wizard-summary__line + .wizard-summary__line {\n  margin-top: 0.35rem;\n}\n\n.wizard-summary__line--accent {\n  color: var(--color-accent);\n  font-size: 0.86rem;\n  font-weight: 600;\n}\n\n.wizard-summary__body {\n  margin: 0;\n  max-height: 12rem;\n  overflow: auto;\n  padding: 0.75rem 0.85rem;\n  border: 1px solid var(--color-border);\n  border-radius: calc(var(--radius) - 2px);\n  background: var(--color-bg, transparent);\n  color: var(--color-text);\n  font: inherit;\n  font-size: 0.88rem;\n  line-height: 1.5;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.wizard-dispatch-actions {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  width: 100%;\n  gap: 0.75rem;\n}\n\n@media (max-width: 640px) {\n  .wizard-summary__row {\n    grid-template-columns: 1fr;\n    gap: 0.35rem;\n  }\n}\n\n.wizard-schedule-field {\n  width: 100%;\n}\n\n.wizard-dispatch-actions .wizard-upload__error {\n  margin: 0;\n}\n\n.wizard-btn--dispatch {\n  display: inline-flex;\n  align-self: flex-start;\n  margin-top: 0.25rem;\n  /* Match Add Files (wizard-btn--secondary) */\n  background: var(--color-btn);\n  color: var(--color-btn-text);\n}\n\n.wizard-btn--dispatch:hover:not(:disabled) {\n  filter: brightness(1.08);\n  background: var(--color-btn-hover);\n}\n\n.wizard-btn--dispatch svg {\n  color: var(--color-icon);\n}\n\n.wizard-upload {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 180px;\n  margin-bottom: 0.75rem;\n  padding: 1.5rem;\n  border: 1px dashed var(--color-border);\n  border-radius: var(--radius);\n  background: var(--color-surface);\n  cursor: pointer;\n  transition: border-color 0.2s ease, background 0.2s ease;\n}\n\n.wizard-upload--disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n.wizard-upload:hover,\n.wizard-upload:focus-visible {\n  border-color: var(--color-accent);\n  background: var(--color-accent-soft);\n  outline: none;\n}\n\n.wizard-upload__input {\n  display: none;\n}\n\n.wizard-upload__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 56px;\n  height: 56px;\n  margin-bottom: 0.75rem;\n  border-radius: 12px;\n  background: var(--color-btn);\n  color: var(--color-icon);\n}\n\n.wizard-upload__icon svg {\n  width: 28px;\n  height: 28px;\n}\n\n.wizard-upload__title {\n  margin: 0 0 0.35rem;\n  font-size: 0.95rem;\n  font-weight: 600;\n}\n\n.wizard-upload__hint {\n  margin: 0;\n  color: var(--color-text-muted);\n  font-size: 0.68rem;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.wizard-upload__error {\n  margin: 0 0 1rem;\n  color: var(--color-secondary);\n  font-size: 0.88rem;\n}\n\n.dispatch-toast {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n}\n\n.dispatch-toast strong {\n  font-size: 0.95rem;\n}\n\n.dispatch-toast span {\n  font-size: 0.85rem;\n  line-height: 1.45;\n  opacity: 0.92;\n}\n\n.dispatch-toast code {\n  font-family: 'Courier New', Courier, monospace;\n  font-size: 0.72rem;\n  opacity: 0.85;\n  word-break: break-all;\n}\n\n.wizard-validation {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 0.75rem;\n  margin-top: 1.25rem;\n}\n\n.wizard-validation__card {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  padding: 1rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius);\n  background: var(--color-surface);\n}\n\n.wizard-validation__card--success {\n  border-color: var(--color-accent);\n}\n\n.wizard-validation__card--success .wizard-validation__count {\n  color: var(--color-accent);\n}\n\n.wizard-validation__card--warning .wizard-validation__count {\n  color: var(--color-secondary);\n}\n\n.wizard-validation__count {\n  font-size: 1.5rem;\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n.wizard-validation__label {\n  color: var(--color-text-muted);\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n}\n\n.wizard-step--disabled {\n  opacity: 0.6;\n  pointer-events: none;\n}\n\n.wizard-input,\n.wizard-textarea {\n  width: 100%;\n  margin-bottom: 1.25rem;\n  padding: 0.85rem 1rem;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius);\n  background: var(--color-surface);\n  color: var(--color-text);\n  font: inherit;\n}\n\n.wizard-input::placeholder,\n.wizard-textarea::placeholder {\n  color: var(--color-text-muted);\n}\n\n.wizard-input:focus,\n.wizard-textarea:focus {\n  outline: none;\n  border-color: var(--color-accent);\n  box-shadow: 0 0 0 3px var(--color-accent-soft);\n}\n\n.wizard-textarea {\n  min-height: 180px;\n  resize: vertical;\n  font-family: 'Courier New', Courier, monospace;\n  line-height: 1.5;\n}\n\n.wizard-attachments {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.75rem;\n  margin-bottom: 0.75rem;\n}\n\n.wizard-attachments__list {\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  border: 1px solid var(--color-border);\n  border-radius: var(--radius);\n  background: var(--color-surface);\n  overflow: hidden;\n}\n\n.wizard-attachments__list li {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto auto;\n  gap: 0.75rem;\n  align-items: center;\n  padding: 0.7rem 0.85rem;\n  border-bottom: 1px solid var(--color-border);\n}\n\n.wizard-attachments__list li:last-child {\n  border-bottom: 0;\n}\n\n.wizard-attachments__name {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 0.9rem;\n  font-weight: 600;\n}\n\n.wizard-attachments__meta {\n  color: var(--color-text-muted);\n  font-size: 0.78rem;\n  white-space: nowrap;\n}\n\n.wizard-attachments__remove {\n  border: 0;\n  background: transparent;\n  color: var(--color-secondary);\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  cursor: pointer;\n  padding: 0;\n}\n\n.wizard-attachments__remove:hover:not(:disabled) {\n  text-decoration: underline;\n}\n\n.wizard-attachments__remove:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.wizard-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.55rem;\n  padding: 0.75rem 1.1rem;\n  border: none;\n  border-radius: var(--radius);\n  background: var(--color-btn);\n  color: var(--color-btn-text);\n  font-size: 0.82rem;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  cursor: pointer;\n  transition: filter 0.2s ease, background 0.2s ease;\n}\n\n.wizard-btn svg {\n  width: 16px;\n  height: 16px;\n  color: var(--color-icon);\n}\n\n.wizard-btn--secondary:hover:not(:disabled),\n.wizard-btn--primary:hover:not(:disabled) {\n  filter: brightness(1.08);\n  background: var(--color-btn-hover);\n}\n\n.wizard-btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.wizard-btn__spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid currentColor;\n  border-top-color: transparent;\n  border-radius: 50%;\n  animation: wizard-spin 0.7s linear infinite;\n}\n\n@keyframes wizard-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.wizard-btn--primary {\n  width: 100%;\n  justify-content: center;\n  margin-top: 0.25rem;\n}\n\n.wizard-footnote {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.45rem;\n  margin: 0.85rem 0 0;\n  color: var(--color-text-muted);\n  font-size: 0.72rem;\n}\n\n.wizard-footnote svg {\n  width: 14px;\n  height: 14px;\n  color: var(--color-icon);\n  padding: 3px;\n  border-radius: 4px;\n  background: var(--color-btn);\n  box-sizing: content-box;\n}\n\n@media (max-width: 768px) {\n  .wizard-step {\n    padding: 1rem;\n  }\n\n  .wizard-upload {\n    min-height: 150px;\n    padding: 1.25rem 1rem;\n  }\n\n  .wizard-validation {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 480px) {\n  .dispatch-wizard__intro p {\n    margin-bottom: 1.25rem;\n  }\n\n  .wizard-step__header h3 {\n    font-size: 0.95rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
